import axios from 'axios';
import { setAxiosApi, setAxiosWeb, setVersion } from './globals';
import { Axios } from './utils/axios';

type Urls = {
  core: string;
  nog: string;
  taco: string;
  soda: string;
  webAssets: string;
};

const LOCAL = 'http://localhost:8080/api';
const PROXY = 'http://localhost:3000/api';
const PRODUCTION = 'https://sloydwebapinode-prod.azurewebsites.net/api';

const defaultUrls = (isProd: boolean) => ({
  core: isProd ? PRODUCTION : PROXY, // prettier-ignore
  webAssets: 'https://storage.googleapis.com/sloyd-assets',
});

export const init = (isProd: boolean, config: Partial<Urls>, version = 1) => {
  const { core, webAssets } = { ...config, ...defaultUrls(isProd) };

  setVersion(version);

  const axiosCore = new Axios(core);
  setAxiosApi(axiosCore);

  const axiosWebAssets = axios.create({ baseURL: webAssets });
  setAxiosWeb(axiosWebAssets);
};
